<template>
  <div>
    <Suspense>
      <template #default>
        <!--PostechTable></PostechTable-->
        <router-view></router-view>
      </template>

      <template #fallback>
        <div>Loading all postech..</div>
      </template>
    </Suspense>
  </div>
</template>

<script setup lang="ts">
//import InvoicesTable from '@/components/Invoices-table.vue';
//import PostechTable from '@/views/postechs/Table.vue';
</script>
